// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer[data-v-6b96cfe8]{border-top:1px solid rgba(0,0,0,.12)!important;z-index:2}.social-link[data-v-6b96cfe8]:hover{text-decoration:none!important}a[data-v-6b96cfe8]{color:#4b586c!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
